import React from 'react';
import DataTable from 'components/data-table';
import { ListAttachTaiLieuRowItem } from 'modules/giai-quyet-don/datatable/rowItem'
import { header } from "constants/table";

class DanhSachTaiLieuDinhKem extends React.Component {

  render() {
    let getFilter = null;
    const arrTitleFile = [
      'Báo cáo kết quả xác minh nội dung khiếu nại',
      'Quyết định về việc giải quyết khiếu nại',
      'Báo cáo kết quả xác minh nội dung tố cáo',
      'Quyết định về việc giải quyết tố cáo',
      'Quyết định giải quyết khiếu nại',
      'Văn bản xác minh đề xuất',
      'Văn bản xử lý kiến nghị, phản ánh',
      'Văn bản giải quyết kiến nghị, phản ánh',
      'Văn bản kết luận, giải quyết tố cáo',
      'Thông báo kết quả giải quyết tố cáo',
      'Báo cáo xác minh',
      'Văn bản giải quyết'
    ];
    getFilter = this.props.parent.filter(item => item.ten !== '' && !arrTitleFile.includes(item.ten) || item.soQuyetDinh !== '' || item.ngayQuyetDinh !== null || item.duongDan !== '');
    return (
      <div>
        <div className="title">
          <div className="rows">
            <div className="col-12">
              <h3>{this.props.title || 'DANH SÁCH TÀI LIỆU ĐÍNH KÈM'}</h3>
            </div>
          </div>
        </div>
        <div className="items-form white-table mb10">
          <div className="rows">
            <div className="col-12">
              <DataTable
                header={header.giaiQuyetDon.danhSachTaiLieuDinhKemDC}
                dataList={getFilter}
                type="handle-letter-detail" hidePagination={true}
                hiddenButtonExport>
                <ListAttachTaiLieuRowItem />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DanhSachTaiLieuDinhKem.defaultProps = {
  listTaiLieuDinhKem: []
}

export default DanhSachTaiLieuDinhKem;



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/DanhSachTaiLieuDinhKem.jsx